import { compact, concat, sortBy } from 'lodash';
import { Injectable } from '@angular/core';

import { ApplicationConfigStep } from '@lockton-apps/shared/interfaces';

@Injectable()
export class ProposalsStepCustomizerService {
  customize(
    dueToRenewal: ApplicationConfigStep[],
    productPicker: ApplicationConfigStep | undefined,
    addons: ApplicationConfigStep[],
    mandatory: ApplicationConfigStep[]
  ): ApplicationConfigStep[] {
    return sortBy(
      compact(concat(dueToRenewal, [productPicker], addons, mandatory)),
      'indexOverride'
    );
  }

  customizeRenewal(
    dueToRenewal: ApplicationConfigStep[],
    productPicker: ApplicationConfigStep | undefined,
    addons: ApplicationConfigStep[],
    mandatory: ApplicationConfigStep[]
  ): ApplicationConfigStep[] {
    return sortBy(compact(concat(dueToRenewal, mandatory)), 'indexOverride');
  }
}
